import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "knudeafgang",
  "use": "knudeafgang-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"knudeafgang\"><path d=\"M26.17 8.87v1h-4.65a8.07 8.07 0 0 0-13 0H4v-1H1.72v9.72h2.06v-1h3.7a8.08 8.08 0 0 0 15.08 0H26v1h2.25V8.87z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".5\" /><circle cx=\"21.63\" cy=\"15.15\" r=\"6.88\" fill=\"#d12027\" /><path d=\"M18.83 16.29V14h5.59v2.29z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/knudeafgang.svg
// module id = n2IH
// module chunks = 1